var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('v-chip',{staticClass:"font",attrs:{"label":"","block":"","small":_vm.$vuetify.breakpoint.mdAndUp,"x-small":_vm.$vuetify.breakpoint.smAndDown,"dark":"","color":_vm.statusColor}},[_vm._v(_vm._s(_vm.status))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }